import { collection, getDocs } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../config/firebase";

const submitClaimCall = httpsCallable(functions, "submitRewardClaim");
const checkClaimCall = httpsCallable(functions, "checkRewardClaim");
const openBoxCall = httpsCallable(functions, "openRewardBox");
const reviewClaimCall = httpsCallable(functions, "reviewRewardClaim");
const updateSettingsCall = httpsCallable(functions, "updateRewardSettings");
const getMonthlyDrawCall = httpsCallable(functions, "getMonthlyDraw");
const getPublicMonthlyDrawCall = httpsCallable(functions, "getPublicMonthlyDraw");
const saveMonthlyDrawCall = httpsCallable(functions, "saveMonthlyDraw");
const deleteMonthlyDrawCall = httpsCallable(functions, "deleteMonthlyDraw");
const runMonthlyDrawCall = httpsCallable(functions, "runMonthlyDraw");

export const submitRewardClaim = async (data) => (await submitClaimCall(data)).data;
export const checkRewardClaim = async (data) => (await checkClaimCall(data)).data;
export const openRewardBox = async (data) => (await openBoxCall(data)).data;
export const reviewRewardClaim = async (data) => (await reviewClaimCall(data)).data;
export const updateRewardSettings = async (data) => (await updateSettingsCall(data)).data;
export const getMonthlyDraw = async (data) => (await getMonthlyDrawCall(data)).data;
export const getPublicMonthlyDraw = async () => (await getPublicMonthlyDrawCall({})).data;
export const saveMonthlyDraw = async (data) => (await saveMonthlyDrawCall(data)).data;
export const deleteMonthlyDraw = async (data) => (await deleteMonthlyDrawCall(data)).data;
export const runMonthlyDraw = async (data) => (await runMonthlyDrawCall(data)).data;

export const getRewardClaims = async () => {
  const snap = await getDocs(collection(db, "solicitudesPremios"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() })).sort((a, b) => {
    const aTime = a.fecha?.toMillis?.() || new Date(a.fecha || 0).getTime();
    const bTime = b.fecha?.toMillis?.() || new Date(b.fecha || 0).getTime();
    return bTime - aTime;
  });
};
